import { Enums } from '../../../../../../libs/services/enums/enums';

export class LogicFault implements Error {
  constructor(public message: string) {
    //Error.captureStackTrace(this, LogicFault);
  }
  public stack?: string;
  public name: string;
}

export class ServerBusinessLogicException {
  constructor(public code: number, public message: string) {}
}

export class ServerError implements Error {
  constructor(jsonError: any, httpStatusCode: number) {
    this.flags = Enums.ServerErrors.Unknown;

    // detect 403 Forbidden as security exceptions
    if (httpStatusCode && httpStatusCode === 403) {
      this.flags |= Enums.ServerErrors.SecurityException;
      this.securityError = true;
    }

    // parse business logic exceptions in format:
    // {
    //    "Data": null,
    //    "ErrorCode": 0,
    //    "ErrorMessage": "Locate Failed. The specified device does not support the locate command.",
    //    "HelpLink": null,
    //    "InnerErrors": [
    //        {
    //            "Data": [],
    //            "ErrorCode": 1707,
    //            "ErrorMessage": "Locate Failed. The specified device does not support the locate command.",
    //            "HelpLink": null,
    //            "InnerErrors": null,
    //            "Ref": "2015-11-06 10:28:18.8173-05:00"
    //        }
    //    ],
    //    "Ref": "2015-11-06 10:28:18.8173-05:00"
    // }

    if (jsonError && jsonError.InnerErrors instanceof Array && jsonError.InnerErrors.length > 0) {
      this.businessLogicError = new ServerBusinessLogicException(
        jsonError.InnerErrors[0].ErrorCode,
        jsonError.InnerErrors[0].ErrorMessage
      );
    }
  }

  public message: string;
  public stack?: string;
  public name: string;
  public flags = null;
  public securityError = null;
  public businessLogicError = null;
  public businessLogic: ServerBusinessLogicException;

  public is = serverErrorType => {
    return !!(this.flags & serverErrorType);
  };

  public addFlag = function (serverErrorType) {
    this.flags |= serverErrorType;
  };
}
